/**
 * These are for getting data out of the GridWidget and turning into a REST call.
 */
export class RestArgument {
  field: string;
  comparator: string;
  value: any;
  valueAsString: string;

  constructor(field: string, comparator: string, value: any, valueAsString?: string) {
    this.field = field;
    this.comparator = comparator;
    this.value = value;
    if (valueAsString != null) {
      this.valueAsString = valueAsString;
    } else {
      this.valueAsString = String(value);
    }
  }

  toString(): string {
    return this.field + this.comparator + this.valueAsString;
  }
}
